module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCool@2x.61f4bfc.webp";